export default __webpack_public_path__ + "static/media/document-logo-3-active.c746218e.svg";